import styled from "@emotion/styled";
import { RequiredThemeKeys } from "../../../util/theme";
import { tooltipTheme } from "../tooltipTheme";

export interface TooltipContainerStyledProps {
    squareCorner: "borderTopLeft" | "borderTopRight" | "borderBottomLeft" | "borderBottomRight" | undefined;
    themeMode: RequiredThemeKeys;
}

export const TooltipContainerStyled = styled("div")<TooltipContainerStyledProps>(
    ({ themeMode }) => `
        background-color: ${tooltipTheme.background(themeMode)};
        border-radius: ${tooltipTheme.borderRadius(themeMode)};
        color: ${tooltipTheme.textColor.body(themeMode)};
        max-width: 256px;
        // Allow breaking inside words so the max-width will work even when a single word is > 256px wide.
        overflow-wrap: break-word;

        font-size: ${tooltipTheme.fontSize.basic(themeMode)};
        line-height: ${tooltipTheme.lineHeight.body(themeMode)};
        font-weight: ${tooltipTheme.fontWeight.body(themeMode)};
    `,
    ({ squareCorner }) => (squareCorner && { [`${squareCorner}Radius`]: 0 }) || ""
);
